<template>
  <div>
    <div>
      <div class="star-container" :style="{
      '--radio-button-color': $store.getters.getRadioButtonColor,
      // '--star-svg-height': `${starHeight}px`
      }">
        <ul class="rating-card__list">
          <li class="rating-card__list__item" v-bind:class="{'-select': model.crowded}"
              v-for="(model, index) in question.answers"
              v-on:click="selectStar(model, index)" v-bind:key="index">
            <label>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" class="star-ico"
                   v-bind:class="{'bounce': model.bounced}">
                <path
                    d="M259.3 17.8L194 150.2 47.9 171.5c-26.2 3.8-36.7 36.1-17.7 54.6l105.7 103-25 145.5c-4.5 26.3 23.2 46 46.4 33.7L288 439.6l130.7 68.7c23.2 12.2 50.9-7.4 46.4-33.7l-25-145.5 105.7-103c19-18.5 8.5-50.8-17.7-54.6L382 150.2 316.7 17.8c-11.7-23.6-45.6-23.9-57.4 0z"/>
              </svg>
              <div class="star-description">{{ model.title }}&nbsp;&nbsp;</div>
            </label>
          </li>
        </ul>


        <label v-for="model in question.answers" v-bind:key="model.uid">
          <input style="display:none;" type="radio"
                 v-bind:id="'star'+ model.uid"
                 v-on:click="setRadio(model.uid)"
                 :value="model.uid"
                 :name="question.uid"
                 :checked="model.selected"
          />
        </label>
        <input type="hidden" class="answerSelected" data-question="question.uid" v-model="answerSelected">
      </div>
    </div>
    <div>
      <transition name="fade">
        <comment v-show="showComment" :placeholder="commentPlaceholder" :name="commentName"></comment>
      </transition>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Comment from './Comment';
import Star from 'vue-rate-it/glyphs/star';


export default {
  name: 'star',
  props: ['question'],
  data() {
    return {
      answerSelected: false,
      showComment: false,
      commentPlaceholder: false,
      commentName: false,
      radioButtonCheckedPath: false,
      radioButtonUncheckedPath: false,
      thumbsUp: '',
      starHeight: 100,
      stars: [{
        value: 1,
        text: '',
        gradientFrom: '#FC8885',
        gradientTo: '#FB7C7F',
        selected: false,
      },
        {
          value: 2,
          text: '',
          gradientFrom: '#FB7A7E',
          gradientTo: '#F96A74',
          selected: false,
        },
        {
          value: 4,
          text: '',
          gradientFrom: '#F8636F',
          gradientTo: '#F75062',
          selected: false,
        },
        {
          value: 5,
          text: '',
          gradientFrom: '#F75165',
          gradientTo: '#F6415A',
          selected: false,
        }
      ]
    }
  },
  created() {
    // register the icon
    this.star = Star
  },
  mounted() {
    this.radioButtonCheckedPath = this.$store.getters.getRadioButtonCheckedPath;
    this.radioButtonUncheckedPath = this.$store.getters.getRadioButtonUnCheckedPath;
    this.starHeight = 58;

    if (this.question.answers.length >= 3) {
      this.starHeight = 58;
    }

    if (this.question.answers.length >= 5) {
      this.starHeight = 58;
    }

    if (this.question.answers.length >= 8) {
      this.starHeight = 58;
    }

    if (this.question.answers.length >= 10) {
      this.starHeight = 58;
    }
  },
  methods: {
    setRadio: function (uid) {
      this.showComment = false;
      this.commentPlaceholder = false;
      this.commentName = false;

      this.$emit("inputClick", uid);

      this.question.answers.forEach((item, index) => {
        if (item.uid === uid) {
          item.selected = true;
          if (item.is_allow_comment) {
            this.showComment = true;
            this.commentPlaceholder = item.comment_placeholder;
            this.commentName = 'comment_' + this.question.uid;
          }
          Vue.set(this.question.answers, index, item);
        } else {
          item.selected = false;
          Vue.set(this.question.answers, index, item);
        }

        this.$emit("checkDependency", uid);
      });
    },
    onRatingSelected(e) {
      this.setRadio(e);
    },
    resetStars() {
      this.question.answers.forEach(model => model.crowded = false)
    },
    selectStar(model, index) {
      console.log('select');
      this.resetStars()
      let i = 0;
      this.setRadio(model.uid);
      const f = () => {
        if (i <= index) {
          this.question.answers[i].crowded = true;
          i++;
          setTimeout(f, 50)
        }
        model.bounced = true;
      }
      model.bounced = false;
      setTimeout(f, 50)
    },
  },
  components: {
    Comment
  }
}
</script>

<style>


@keyframes bounce {
  0% {
    width: 58px;
    height: 58px;
  }
  25% {
    width: 58px;
    height: 58px;
  }
  50% {
    width: 58px;
    height: 58px;
  }
  100% {
    width: 58px;
    height: 58px;
  }
}


</style>
<style lang="scss">
.rating-card__list {
  margin: 0;
  padding: 0;
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  flex-basis: auto;

  &__item {
    flex-basis: 20%;
    flex-grow: 1;
    font-size: 12px;

    .-checked & {
      font-weight: 200;
    }

    input {
      display: none;
    }

    input:checked + label {
      font-weight: 500;
    }

    svg {
      width: 58px;
      height: 58px;

      &:hover {
        cursor: pointer;
      }

      path {
        fill: #e6e7ea;
      }
    }

    &.-select {
      svg {
        path {
          fill: var(--radio-button-color)
        }
      }
    }
  }
}


.star-container {
  width: 100%;
  min-width: 80%;
  margin: 0 auto;
  height: 100px;
  margin-top: 35px;
  text-align: center;
  --radio-button-color: #283f87;
  --star-svg-height: 58px;
}

.star-description {
  font-weight: 200;
  margin-top: -40px;
  margin: 0 auto;
  margin-top: -42px;
  color: #FFF;
  font-weight: bold;
  font-size: 1.5em;
  text-align: center;
  margin-left: 8px;
}

@media (max-width: 450px) {

  .star-description {
    margin-top: -40px;
    margin-left: 8px;
  }

  .rating-card__list {

    &__item {

      svg {
        width: 45px !important;
        height: 45px !important;;
      }
    }
  }
}

@media (max-width: 320px) {

  .star-description {
    margin-top: -36px;
    margin-left: 12px;
  }

  .rating-card__list {

    &__item {
      padding-left: 0 !important;

      svg {
        width: 40px !important;
        height: 40px !important;;
      }
    }
  }
}

@media (min-width: 1024px) {

  .star-container {
    width: 400px;
    min-width: 400px;

  }

  .star-description {
    margin-top: -48px;
    margin-left: 12px;
    font-size: 1.8em;

  }

  .rating-card__list {

    &__item {
      padding-left: 0 !important;

      svg {
        width: 60px !important;
        height: 60px !important;;
      }
    }
  }
}

</style>
